import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./authContext";
import { AuthContextState } from "../../utils/types";
import pathConstant from "../../utils/path.constant";
import React from "react";
import AccessDenied from "../../components/pages/error/accessDenied";
import Loading from "../../components/pages/Loading";

interface privilegeAccessProps {
    priv_id : number
}

const ProtectedRoutes : React.FC<privilegeAccessProps> = ({priv_id}) =>{
    const {isAuthenticated, loading, decodedJwtData} = useAuth() as AuthContextState;
    const user_priv  = decodedJwtData?.account_priv;
    const location = useLocation();

    localStorage.setItem('lastProtectedRouted', location.pathname);

    if(loading) {
        return(
            <Loading />
        );
    }

    if (priv_id === -1 && isAuthenticated) return <Outlet />

    if(!user_priv?.includes(priv_id) && isAuthenticated) return <AccessDenied />

    return isAuthenticated ? <Outlet /> : <Navigate to={pathConstant.LOGOUT} />
}

export default ProtectedRoutes;